// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3raCI","colMaxWidth":"Table_colMaxWidth__no0WL"};